window.tp = window.tp || [];
window.tp.push( [
	"init",
	function () {
		window.tp.pianoId.show( {
			displayMode: "inline",
			screen: "restore",
			containerSelector: "#password-form",
		} );
	},
] );
